// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-dialog__content__body[data-v-3d29e480]{display:flex}.ui-dialog__content__body .ui-dialog__content__body__pin-input[data-v-3d29e480]{margin-left:16px;max-width:248px}.ui-dialog__content__body .ui-dialog__content__body__pin-input[data-v-3d29e480] input{width:100%}\n", ""]);
// Exports
module.exports = exports;
